/**
 * Whether a value is a non-null, non-array object whose keys can be read safely.
 * Used to narrow `unknown` API data before reading named fields from it.
 */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** `value` when it is a record, else `{}`, so a reader can look up named fields without null checks. */
export function recordOrEmpty(value: unknown): Record<string, unknown> {
  return isRecord(value) ? value : {};
}
